import { render } from "./EditHotspot.vue?vue&type=template&id=b638c752&scoped=true&ts=true"
import script from "./EditHotspot.vue?vue&type=script&lang=ts"
export * from "./EditHotspot.vue?vue&type=script&lang=ts"

import "./EditHotspot.vue?vue&type=style&index=0&id=b638c752&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b638c752"]])

export default __exports__